import { useQuery } from '@tanstack/react-query';
import { makeRequest } from '../../../entry-form-v2/data/makeRequest';
import { CodelistRecord } from '../../domain/codelistRecordSchema';

type GetCodelistRecordHistoryResponse = {
	events: CodelistRecordChangedEvent[];
};

export type CodelistHistoryEventType =
	| 'CREATE_RECORD'
	| 'UPDATE_RECORD'
	| 'IMPORT_BULK_RECORDS'
	| 'PARTIAL_IMPORT_RECORDS';

export type CodelistImportBulkRecordsEvent = {
	eventType: 'IMPORT_BULK_RECORDS';
	metadata: {
		records: CodelistRecord[];
	};
	createdAt: string;
	userId: string;
};
export type CodelistCreateRecordEvent = {
	eventType: 'CREATE_RECORD';
	metadata: {
		record: CodelistRecord;
	};
	createdAt: string;
	userId: string;
};
export type CodelistUpdateRecordEvent = {
	eventType: 'UPDATE_RECORD';
	metadata: {
		record: CodelistRecord;
	};
	createdAt: string;
	userId: string;
};
export type CodelistPartialImportRecordsEvent = {
	eventType: 'PARTIAL_IMPORT_RECORDS';
	metadata: {
		records: CodelistRecord[];
	};
	createdAt: string;
	userId: string;
};
export type CodelistRecordChangedEvent =
	| CodelistCreateRecordEvent
	| CodelistUpdateRecordEvent
	| CodelistImportBulkRecordsEvent
	| CodelistPartialImportRecordsEvent;

export const useGetCodelistRecordHistoryQuery = (
	args: {
		projectId: string;
		originalEntryId: string;
	},
	opts?: {
		enabled?: boolean;
	}
) => {
	return useQuery({
		queryKey: ['codelist-record-history', args.projectId, args.originalEntryId],
		queryFn: () =>
			makeRequest<GetCodelistRecordHistoryResponse>({
				method: 'getCodelistRecordHistory',
				service: 'cde',
				data: {
					projectId: args.projectId,
					originalEntryId: args.originalEntryId
				}
			}),
		...opts
	});
};
